import React from "react";
import {
  GroupChannelListItemBasicProps
} from "@sendbird/uikit-react/types/modules/GroupChannelList/components/GroupChannelListItem/GroupChannelListItemView";

import './ConversationPreview.css';
import { formatTimestamp } from "../../../utils/formatTimestamp";
import { ConversationAvatar } from "../../ConversationAvatar/ConversationAvatar";
import { useTranslation } from "react-i18next";
import { useConversationRespondent } from "../../../utils/useConversationRespondent";

type Props = {
  conversation: GroupChannelListItemBasicProps;
  isSelected: boolean;
  onClick: () => void;
}

export function ConversationPreview({ conversation, isSelected, onClick }: Props) {
  const { t } = useTranslation();
  const lastMessage = conversation.channel.lastMessage;
  const isGroupChat = conversation.channel.customType === "group";
  const { respondent, displayName, avatarUrl } = useConversationRespondent(
    conversation.channel,
    isGroupChat
  );

  return (
    <button onClick={onClick} className={`conversation-preview ${isSelected ? 'conversation-preview_selected' : ''}`}>
      <div className="conversation-preview__avatar">
      <ConversationAvatar
        groupName={isGroupChat ? conversation.channel.name : undefined}
        user={respondent}
        size={32}
        displayName={displayName || undefined}
        avatarUrlOverride={avatarUrl || undefined}
      />
      </div>
      <div className="conversation-preview__info">
        <div className="conversation-preview__top-row">
          <div className="conversation-preview__name">
            {isGroupChat ? conversation.channel.name : (displayName || respondent?.nickname)}
            {conversation.channel.unreadMessageCount > 0 && (
              <span className="conversation-preview__unread-count">{
                conversation.channel.unreadMessageCount
              }</span>
            )}
          </div>
          <div className="conversation-preview__last-message-time">
            {lastMessage ? formatTimestamp(lastMessage.createdAt) : ''}
          </div>
        </div>
        <div className="conversation-preview__last-message">
          {conversation.isTyping ? t('messages.is_typing') : lastMessage?.message}
        </div>

      </div>
    </button>
  );
}
